<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto">
    <DataGetter
      v-if="isLoading"
      @dataAvailable="
        data => {
          if (!data?.metaData?.withdrawals) return
          totalPages = Math.ceil(data?.metaData?.total / 8)
          transactions = data?.metaData?.withdrawals
          this.isLoading = false
        }
      "
      :searchQuery="{ page: currentPage, limit: 8 }"
      contentId="withdrawalsByBank"
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Reversements</div>
    </div>
    <div class="py-4"></div>

    <div v-if="isLoading || transactions.length > 0">
      <div class="py-4"></div>
      <div class="relative">
        <div class="w-full overflow-auto">
          <div>
            <div
              class="flex items-center justify-between p-4 rounded-2xl text-sm uppercase gap-8"
            >
              <div class="flex items-center gap-4 w-[15rem] min-w-[15rem]">
                Intitulé du compte
              </div>

              <div class="flex gap-6 w-[12rem] min-w-[12rem]">Montant</div>

              <div class="flex gap-6 w-[15rem] min-w-[15rem]">
                Détails du compte
              </div>

              <div class="flex gap-6 w-[10rem] min-w-[10rem]">Date & Heure</div>

              <!-- Price and Quantity -->
              <div
                class="flex gap-6 w-[15rem] min-w-[15rem] justify-center text-center pr-4"
              >
                Status
              </div>
              <div
                class="flex gap-6 w-[8rem] min-w-[8rem] justify-center text-center pr-4"
              >
                Action
              </div>
            </div>
          </div>
          <div class="flex flex-col gap-4">
            <div
              v-for="(withdrawal, index) in isLoading
                ? shimmerAccounts
                : transactions"
              :key="index"
              class="flex items-center justify-between min-w-max p-4 rounded-2xl gap-8 [&>div]:relative"
              :class="{ shimmerElement: withdrawal.shimmer }"
            >
              <div
                class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[5lh] bg-white p-"
              ></div>
              <!-- Account Info -->
              <div class="flex items-center gap-4 w-[15rem] min-w-[15rem]">
                <img
                  :src="withdrawal?.withdrawalAccount?.image"
                  :class="{
                    'opacity-0': !withdrawal?.withdrawalAccount?.image,
                  }"
                  class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-lg"
                />
                <div class="w-[11rem]">
                  <h3
                    class="font-semibold title-color ripple"
                    @click="
                      $Commons.copy(
                        withdrawal.withdrawalAccount?.fullName,
                        'Copié',
                      )
                    "
                  >
                    <span>
                      <img
                        src="@/assets/images/all/copy.svg"
                        class="w-5 h-5 inline"
                        alt=""
                      />
                    </span>
                    {{ withdrawal.withdrawalAccount?.fullName }}
                  </h3>
                  <h3 class="title-color">
                    {{
                      this.$Countries.find(
                        withdrawal.withdrawalAccount?.countryCode,
                      )?.countryName
                    }}
                  </h3>
                </div>
              </div>

              <!-- Price and Quantity -->
              <div class=" gap-6 w-[12rem] min-w-[12rem] ">
                <div>Demandé : <span class="title-color"> {{ withdrawal.amount }}&nbsp;FCFA</span></div>
                <div>Prélevé : <span class="title-color"> {{ withdrawal.amountToCollect }}&nbsp;FCFA</span></div>
                <div>Déposé : <span class="title-color"> {{ withdrawal.amountToDeposit }}&nbsp;FCFA</span></div>
              </div>

              <!-- Price and Quantity -->
              <div class="gap-6 w-[15rem] min-w-[15rem]">
                <div
                  class="ripple truncate"
                  @click="
                    $Commons.copy(
                      withdrawal.withdrawalAccount?.metadata?.accountId,
                      'Copié',
                    )
                  "
                >
                  <span>
                    <img
                      src="@/assets/images/all/copy.svg"
                      class="w-5 h-5 inline"
                      alt=""
                    />
                  </span>
                  Id: {{ withdrawal.withdrawalAccount?.metadata?.accountId }}
                </div>
                <div
                  class="ripple truncate"
                  @click="
                    $Commons.copy(
                      withdrawal.withdrawalAccount?.metadata?.bankName,
                      'Copié',
                    )
                  "
                >
                  <span>
                    <img
                      src="@/assets/images/all/copy.svg"
                      class="w-5 h-5 inline"
                      alt=""
                    />
                  </span>
                  Banque: {{ withdrawal.withdrawalAccount?.metadata?.bankName }}
                </div>
                <div
                  class="ripple truncate"
                  @click="
                    $Commons.copy(
                      withdrawal.withdrawalAccount?.metadata?.bankCode,
                      'Copié',
                    )
                  "
                >
                  <span>
                    <img
                      src="@/assets/images/all/copy.svg"
                      class="w-5 h-5 inline"
                      alt=""
                    />
                  </span>
                  Code Banque:
                  {{ withdrawal.withdrawalAccount?.metadata?.bankCode }}
                </div>
                <div
                  class="ripple truncate"
                  @click="
                    $Commons.copy(
                      withdrawal.withdrawalAccount?.metadata?.boxCode,
                      'Copié',
                    )
                  "
                >
                  <span>
                    <img
                      src="@/assets/images/all/copy.svg"
                      class="w-5 h-5 inline"
                      alt=""
                    />
                  </span>
                  Code Guichet:
                  {{ withdrawal.withdrawalAccount?.metadata?.boxCode }}
                </div>
              </div>

              <!-- Price and Quantity -->
              <div class="flex gap-6 w-[10rem] min-w-[10rem]">
                {{
                  withdrawal.date
                    ? $Commons.timestampToDate(
                        withdrawal.date,
                        'DD MMM YYYY hh[h] mm',
                      )
                    : '-'
                }}
              </div>

              <!-- Price and Quantity -->
              <div
                class="flex gap-6 w-[15rem] min-w-[15rem] justify-center pr-4"
              >
                <button
                  class="whitespace-nowrap px-4 py-2 font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg"
                  :style="{
                    backgroundColor: statuses[withdrawal.status]?.background,
                    color: statuses[withdrawal.status]?.color,
                  }"
                >
                  {{ statuses[withdrawal.status]?.name }}
                </button>
              </div>

              <!-- SKU -->
              <!-- <div class=" text-gray-700">{{ account.sku }}</div> -->

              <!-- Actions -->
              <div
                class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
              >
                <DropdownComponent
                  :selects="
                    withdrawal.status == 'paidWaiting'
                      ? [
                          {
                            name: 'Valider',
                            onClick() {
                              validateWithdrawal(withdrawal)
                            },
                          },
                          {
                            name: 'Annuler & rembourser',
                            onClick() {
                              cancelWithdrawal(withdrawal)
                            },
                          },
                        ]
                      : []
                  "
                  hideArrow
                  maxHeight="270px"
                  displayKey="name"
                  toLeft
                  :onSelect="
                    selected => {
                      selected.onClick()
                    }
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                    />
                  </svg>
                </DropdownComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="py-2"></div>
      <div class="flex justify-center">
        <Pagination
          v-if="!isLoading"
          :currentPage="currentPage"
          :totalPages="totalPages"
          @pageClick="newPage => (currentPage = newPage)"
        />
      </div>
    </div>
    <div
      class="h-[60vh] w-full flex-col items-center justify-center flex"
      v-else
    >
      <div class="w-1/5">
        <img src="@/assets/images/empty/bank.png" alt="" />
      </div>
      <div class="py-1"></div>
      <div class="text-center">
        <div class="py-1"></div>
        <div class="text-4xl title-color font-bold">
          Aucun Reversement effectué
        </div>
        <div class="py-1"></div>
        <div class="text-lg">
          Utilisé le bouton détails des compte de reversements pour lancer un
          reversement
        </div>
        <div class="py-3"></div>
        <div class="flex justify-center gap-6">
          <button @click="activeTab = 'accounts'" class="buttonComponent">
            Comptes de reversements
          </button>
        </div>
      </div>
    </div>

    <EventListener
      :events="[
        'withdrawal_validated',
        'failed_to_validate_withdrawal',
        'withdrawal_rejected',
        'failed_to_rejecte_withdrawal',
      ]"
      @withdrawal_validated="onWithdrawalValidated"
      @failed_to_validate_withdrawal="onWithdrawalNotValidated"
      @withdrawal_rejected="onWithdrawalRejected"
      @failed_to_rejecte_withdrawal="onWithdrawalNotRejected"
    />
  </div>
</template>

<script>
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'
import Pagination from '../utils/Pagination.vue'

export default {
  name: 'homeComponent',
  components: {
    DataGetter,
    DropdownComponent,
    EventListener,
    Pagination,
  },
  data() {
    return {
      eventsIds: [],
      isLoading: true,
      totalPages: 0,
      currentPage: 1,
      transactions: [],
      shimmerAccounts: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],

      statuses: {
        pending: {
          id: 'pending',
          name: 'En attente',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        paidWaiting: {
          id: 'pending',
          name: 'Défalqué, En attente',
          background: '#FFF0E7',
          color: '#BC5C2E',
        },
        success: {
          id: 'success',
          name: 'Réussi',
          background: '#EAEEFF',
          color: '#2930B5',
        },
        error: {
          id: 'error',
          name: 'Echoué',
          background: '#EEF2F3',
          color: '#696969',
        },
        canceled: {
          id: 'error',
          name: 'Annulé & remboursé',
          background: '#EEF2F3',
          color: '#696969',
        },
      },
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {
    async validateWithdrawal(withdrawal) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez vous vraiment valider le reversement de ${withdrawal.amount} FCFA ?`,
          subTitle: 'Vous ne pouvez plus annuler un reversement validé',

          successText: 'Valider le reversement',
          cancelText: 'Retour',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Validation en cours',
        body: 'Le reversement est en cours de validation',
      })
      this.$Events.dispatchEvent('withdrawal_validation_requested', withdrawal)
    },
    onWithdrawalValidated() {
      this.isLoading = true
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Reversement validé',
        body: 'Le reversement a été validé avec succès',
      })
    },
    onWithdrawalNotValidated() {
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Non validé',
        body: "Une erreur s'est produite lors de la validation. Veuillez réessayer.",
      })
    },

    async cancelWithdrawal(withdrawal) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez vous vraiment annuler ce reversement de ${withdrawal.amount} FCFA ?`,
          subTitle: `Le montant prélevé de  ${withdrawal.amountToCollect} FCFA sera reversé sur le solde du marchand`,

          successText: 'Annuler et rembourser',
          cancelText: 'Quitter',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Annulation en cours',
        body: "Le reversement est en cours d'annulation",
      })
      this.$Events.dispatchEvent('withdrawal_rejection_requested', withdrawal)
    },
    onWithdrawalRejected() {
      this.isLoading = true
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Reversement annulé',
        body: 'Le reversement a été annulé avec succès',
      })
    },
    onWithdrawalNotRejected() {
      this.$Events.dispatchEvent('toast_notification', {
        title: "Echec d'annulation",
        body: "Une erreur s'est produite lors de l'annulation. Veuillez réessayer.",
      })
    },
  },
  watch: {
    currentPage() {
      this.isLoading = true
    },
    activeStatus() {
      this.isLoading = true
      this.currentPage = 1
    },
  },
}
</script>
